"use strict";Object.defineProperty(exports, "__esModule", {value: true});// One-shot, sessionStorage-backed flag: the self-serve terminal legs set it just
// before landing in the inbox, and the inbox's download modal consumes it once on
// mount. The user finishes onboarding inside the working inbox — never on a
// standalone download screen — and a reload never re-shows the prompt.
//
// Lives in its own module (no component imports) so bootstrap-time listeners can
// read it without pulling the onboarding screens into their import graph.
const SHOW_DOWNLOAD_MODAL_KEY = 'onb_show_download_modal'

// Sticky breadcrumb set alongside the one-shot flag: lets the first-login
// interactables listener tell this session arrived from the onboarding
// continuation even after the modal consumed its flag. Cleared at logout
// (clearOnboardingBreadcrumbs) — it marks ONE user's arrival, and surviving
// into the next login on a shared tab would suppress that user's first-run
// welcome/SMS prompts.
const FROM_ONBOARDING_KEY = 'onb_from_onboarding'

/** Arm the post-onboarding download modal to appear once on the next inbox mount. */
 const markShowDownloadModal = () => {
  try {
    sessionStorage.setItem(SHOW_DOWNLOAD_MODAL_KEY, '1')
    sessionStorage.setItem(FROM_ONBOARDING_KEY, '1')
  } catch (e) {
    // best-effort; storage may be unavailable in private modes
  }
}; exports.markShowDownloadModal = markShowDownloadModal

/**
 * Read-and-clear the download-modal flag. Returns true at most once per arming,
 * so the modal shows a single time and never re-appears on reload.
 */
 const consumeShowDownloadModal = () => {
  try {
    if (!sessionStorage.getItem(SHOW_DOWNLOAD_MODAL_KEY)) return false
    sessionStorage.removeItem(SHOW_DOWNLOAD_MODAL_KEY)
    return true
  } catch (e2) {
    return false
  }
}; exports.consumeShowDownloadModal = consumeShowDownloadModal

/** True when this session reached the inbox via the onboarding continuation. */
 const arrivedFromOnboarding = () => {
  try {
    return !!sessionStorage.getItem(FROM_ONBOARDING_KEY)
  } catch (e3) {
    return false
  }
}; exports.arrivedFromOnboarding = arrivedFromOnboarding

/**
 * Drops both onboarding markers. Called at logout: they describe the user who
 * just left, and a first-time user logging in next on this tab must get their
 * own welcome/SMS prompts (and no stale download modal).
 */
 const clearOnboardingBreadcrumbs = () => {
  try {
    sessionStorage.removeItem(SHOW_DOWNLOAD_MODAL_KEY)
    sessionStorage.removeItem(FROM_ONBOARDING_KEY)
  } catch (e4) {
    // best-effort; storage may be unavailable in private modes
  }
}; exports.clearOnboardingBreadcrumbs = clearOnboardingBreadcrumbs
